import React from 'react'
import ReactDOM from 'react-dom'

const SelectLocation = ({ data, setData, handleChangeLocation }) => {
    return (data && data.data && data.data.current_location) ? <span
        className={ `happy-order__delivery-select-location`}
        data-id={ data.data.current_location ? data.data.current_location.ID : null }
        onClick={ handleChangeLocation }
    >
        { data.data.current_location ? data.data.current_location.CITY : 'Не определён' }
    </span> : <span
        className={ `happy-order__delivery-select-location`}
        data-id={ null }
        onClick={ handleChangeLocation }
    >
        Не определён
    </span>
}

export default SelectLocation